import * as React from 'react';
import {
  Box,
  Button,
  TextField,
  Typography
} from '@mui/material'

import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import SmartToyIcon from '@mui/icons-material/SmartToy';

import { login, getUser } from '../slices/auth';

const Login = (props) => {
  const [username, setUsername] = React.useState("");
  const [password, setPassword] = React.useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  React.useEffect(()=> {
    const role = localStorage.getItem("role")
    if(role === 'USER') navigate('/chat')
    else if(role === 'ADMIN' || role === 'SUPER_ADMIN')
      navigate('/admin')
  }, [navigate]);

  const handleUsername = (e) => {
    setUsername(e.target.value);
  }

  const handlePassword = (e) => {
    setPassword(e.target.value);
  }

  const handleSubmit = (e) => {
    let formData = new FormData();
    formData.append('username', username);
    formData.append('password', password);
    dispatch(login(formData)).then(res => {
      const {type} = res.payload;
      dispatch(getUser());
      if(type === 'USER')
        navigate('/chat');
      else if(type === 'ADMIN' || type === 'SUPER_ADMIN')
        navigate('/admin');
    }).catch(err => console.log(err));
  }

  return (
    <Box
      sx={{
        width: '100%',
        height: '100vh',
        background: 'linear-gradient(135deg, #e8edf5 0%, #dce4f0 100%)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Box
        sx={{
          width: 400,
          background: '#ffffff',
          borderRadius: '20px',
          boxShadow: '0 8px 40px rgba(0,0,0,0.10)',
          p: '40px 44px 44px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'stretch',
          gap: 0,
        }}
      >
        {/* Logo */}
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 1.5, mb: 4 }}>
          <SmartToyIcon sx={{ fontSize: '2.2rem', color: '#1878C6' }} />
          <Typography sx={{ fontSize: '1.45rem', fontWeight: 700, color: '#1878C6', fontFamily: 'Arial, Helvetica, sans-serif' }}>
            AnalyticsChat
          </Typography>
        </Box>

        {/* Email */}
        <TextField
          required
          name="username"
          label="Email"
          variant="filled"
          onChange={handleUsername}
          InputProps={{ disableUnderline: true }}
          sx={{
            mb: 2,
            '& .MuiFilledInput-root': {
              borderRadius: '10px',
              backgroundColor: '#eef2f9',
              '&:hover': { backgroundColor: '#e6ecf5' },
              '&.Mui-focused': { backgroundColor: '#e6ecf5' },
            },
            '& .MuiInputLabel-root': { fontSize: '0.9rem' },
          }}
        />

        {/* Password */}
        <TextField
          required
          name="password"
          label="Password"
          type="password"
          variant="filled"
          onChange={handlePassword}
          InputProps={{ disableUnderline: true }}
          sx={{
            mb: 3.5,
            '& .MuiFilledInput-root': {
              borderRadius: '10px',
              backgroundColor: '#eef2f9',
              '&:hover': { backgroundColor: '#e6ecf5' },
              '&.Mui-focused': { backgroundColor: '#e6ecf5' },
            },
            '& .MuiInputLabel-root': { fontSize: '0.9rem' },
          }}
        />

        {/* Sign in button */}
        <Button
          variant="contained"
          onClick={handleSubmit}
          sx={{
            fontSize: '1rem',
            fontWeight: 600,
            borderRadius: '50px',
            textTransform: 'none',
            background: '#4F46E5',
            py: 1.4,
            boxShadow: '0 4px 14px rgba(79, 70, 229, 0.35)',
            '&:hover': {
              background: '#4338CA',
              boxShadow: '0 6px 18px rgba(79, 70, 229, 0.45)',
            },
          }}
        >
          Sign in
        </Button>
      </Box>
    </Box>
  )
}

export default Login;
